export default interface IndigoMessage<Payload> {
    source: string;

    channelId: number;

    connectionId: number;

    messageNumber: number;

    requestId: number;

    payload: Payload;
}

export enum IndigoRequestMessageType {
    STOP_STREAMING = 'STOP_STREAMING',
}
